// extracted by mini-css-extract-plugin
export default {"tableCell":"style--tableCell--087413"};